import { create } from '@yornaath/batshit';
import { portalLandingPageElementsApi } from 'store/api';
import { IPortalLandingPageElement } from 'api/digifi/PortalLandingPageElementsApi';
import { IGenerateImageUrlsParams } from 'api/digifi/portal-page-elements/BasePortalPageElementsApi';
import { apiSlice } from './apiSlice';

const imageUrlsBatcher = create({
  fetcher: async (queries: IGenerateImageUrlsParams[]) => {
    const imageUrlsParams = queries.reduce(
      (combinedParams, params) => ({
        imageElementIds: [...(combinedParams.imageElementIds || []), ...(params.imageElementIds || [])],
      }),
      {} as IGenerateImageUrlsParams,
    );

    return portalLandingPageElementsApi.generateImageUrls(imageUrlsParams);
  },
  resolver: (items) => items,
});

export const portalLandingPageElementsSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPortalLandingPageElements: builder.query<
      IPortalLandingPageElement[],
      void
    >({
      queryFn: async () => {
        try {
          const result = await portalLandingPageElementsApi.find({});

          return { data: result };
        } catch (error) {
          return { error };
        }
      },
    }),
    generateLandingPageImageUrls: builder.mutation<
      Record<string, string>,
      IGenerateImageUrlsParams
    >({
      queryFn: async (params) => {
        const result = await imageUrlsBatcher.fetch(params);

        return { data: result };
      },
    }),
  }),
});

export const {
  useGetPortalLandingPageElementsQuery,
  useGenerateLandingPageImageUrlsMutation,
} = portalLandingPageElementsSlice;
